import { createContext } from "react";

export enum VgtVariant {
  Default = "default",
  Giftee = "giftee",
}

export type VgtVariantProps = {
  variant: VgtVariant;
};

const Context = createContext<VgtVariantProps | null>(null);

export default Context;
